/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsSetClusterCurrency } from "../../funcs/llmModelsSetClusterCurrency.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.PutClusterCurrencyBody$inboundSchema,
};

export const tool$llmModelsSetClusterCurrency: ToolDefinition<typeof args> = {
  name: "llm-models-set-cluster-currency",
  description: `Set the cluster currency

Sets the cluster-wide currency. Changing it does not auto-convert existing prices.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsSetClusterCurrency(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
